import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

const BackgroundKeyframe = keyframes`
  0% {
    opacity: 0;
   }
  100% {
    opacity: 1;
  }
`;

const HeroTextKeyframe = keyframes`
  0% {
    opacity: 0;
    top: 20px;
   }
  100% {
    opacity: 1;
    top: 0;
  }
`;

export const Caption = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 6rem;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -3.84px;
  ${mediaQuery.maxWidth.desktop} {
    font-size: 5rem;
  }

  ${mediaQuery.maxWidth.tablet} {
    font-size: 3.5rem;
    line-height: 110%;
    letter-spacing: -1.12px;
  }
  ${mediaQuery.maxWidth.phone} {
    font-size: 2.5rem;
    line-height: 110%;
    letter-spacing: -1.12px;
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DescriptionImage = styled.img`
  ${mediaQuery.maxWidth.tablet} {
    display: none;
  }
`;
export const DescriptionMobileImage = styled.img`
  display: none;
  max-width: min(100%, 500px);
  margin: 0 auto;
  ${mediaQuery.maxWidth.tablet} {
    display: initial;
  }
`;

export const CheckMarkIcon = styled.img`
  width: 36px;
  height: 36px;

  ${mediaQuery.maxWidth.tablet} {
    width: 24px;
    height: 24px;
  }
`;

export const CtaWrapper = styled.div`
  display: flex;
  opacity: 0;
  position: relative;
  justify-content: center;
  margin-top: 5px;
  animation: ${HeroTextKeyframe};
  animation-delay: 1s;
  animation-duration: 1500ms;
  animation-fill-mode: forwards;
  margin-bottom: 40px;
  gap: 24px;
  ${mediaQuery.maxWidth.tablet} {
    margin-top: 35px;
    margin-bottom: 0;
  }
`;

export const ButtonLink = styled.div`
  color: black;
  cursor: pointer;
  background-color: white;
  border-radius: 48px;
  padding: 20px 72px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  text-transform: uppercase;

  a,
  span {
    text-decoration: none;
    font-family: ${({ theme }) => theme.fontFamily.bold};
    letter-spacing: 1px;
    font-size: 1rem;
    text-transform: uppercase;
    color: black;
    ${mediaQuery.maxWidth.tablet} {
      font-size: 0.75rem;
    }
  }

  img {
    height: 24px;
    width: 24px;
  }

  &:hover {
    scale: 1.1;
  }

  ${mediaQuery.maxWidth.phone} {
    width: 100%;
    font-size: 0.75rem;
    padding: 12px 32px;
  }
`;

export const TextLine = styled.p`
  margin: 0;
`;

export const Wrapper = styled.div`
  position: relative;
  max-width: 2000px;
  margin: 0 auto;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 20px;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (orientation: landscape) and (max-height: 700px) {
    position: relative;
    bottom: unset;
    left: unset;
    transform: none;
    padding-bottom: 30px;
  }
  text-align: center;
`;

export const TextBox = styled.div`
  margin-top: 25px;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 5;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

export const CornerImage = styled.img`
  position: absolute;
  top: -300px;
  left: -350px;

  animation: ${BackgroundKeyframe};
  animation-duration: 2000ms;
  animation-fill-mode: forwards;
  transform: translate3d(0, 0, 0);
`;

export const Image = styled.img`
  position: absolute;
  bottom: -280px;
  left: -380px;
  width: 175%;

  animation: ${BackgroundKeyframe};
  animation-duration: 2000ms;
  animation-fill-mode: forwards;
  transform: translate3d(0, 0, 0);

  ${mediaQuery.maxWidth.tablet} {
    width: 230%;
    top: 0;
    height: 500px;
  }
`;
